import React from "react";

import styled from "styled-components";
const Input = styled.input`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  height: 50px;
  width: 100%;
  margin-bottom: 8px;

  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
  ::placeholder {
    font-family: Secular One;
    color: #929292;
  }
  color: #929292;
  padding-left: 16px;
`;

const PlainInput = styled.input`
  background: #ffffff;
  height: 50px;
  width: 100%;
  margin-bottom: 8px;
  border-width: 0px;
  border: none;
  :focus {
    outline: none !important;
  }

  ::placeholder {
    font-family: Secular One;
    color: #929292;
  }
  color: #929292;
  padding-left: 16px;
`;

const FlatInput = styled.input`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;

  border-radius: 20px;
  height: 50px;
  width: 100%;
  margin-bottom: 8px;

  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
  ::placeholder {
    font-family: Secular One;
    color: #929292;
  }
  color: #929292;
  padding-left: 16px;
`;

const LuxuryInput = styled.input`
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 0 !important;
  box-sizing: border-box !important;
  border: 1px solid rgb(37, 37, 37) !important;
  background-color: #fff;
  outline: 0;

  margin: 0;
  font-family: inherit;
  overflow: visible;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  min-height: 38px !important;
  border-radius: 0 !important;
  box-sizing: border-box !important;
  border: 1px solid rgb(37, 37, 37) !important;
  padding-right: calc(1.5em + 0.75rem);
  // border-color: #dc3545 !important;
  border-color: #000000 !important;

  :focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

const FormInput = (props) => {
  const { value } = props.input;

  if (props.inputStyle === "plain") {
    return (
      <PlainInput onChange={props.input.onChange} {...props} value={value} />
    );
  }

  if (props.inputStyle === "flat") {
    return (
      <FlatInput onChange={props.input.onChange} {...props} value={value} />
    );
  }

  if (props.inputStyle === "luxury") {
    return (
      <LuxuryInput onChange={props.input.onChange} {...props} value={value} />
    );
  }

  return <Input onChange={props.input.onChange} {...props} value={value} />;
};

export default FormInput;
